import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

const ButtonComponent = ({ className, variant, onClick, isLoading, text, ...rest }) => {
  const btnClass = className || "btnStyle";
  const btnVariant = variant || undefined;

  return (
    <Button className={btnClass} onClick={onClick} variant={btnVariant} {...rest}>
      {isLoading ? <Spinner animation="border" size="sm" /> : text}
    </Button>
  );
};

ButtonComponent.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

ButtonComponent.defaultProps = {
  className: "btnStyle",
  variant: undefined,
  onClick: () => {},
  isLoading: false,
};

export default ButtonComponent;


